import { SSE } from "../../common/apiUrl/sse/sseUrl";
import { API } from "../../common/model/objectTypes";
import { documentRequestTemplateInfo } from "../../utils/apiDescription/sse/documentRequestTemplate";
import { API_BASE_URL } from "../../utils/constants";
import { commonRequestHeader } from "../../utils/objectTypeConstants";
import { documentRequestTemplateBody, documentRequestTemplateResponse } from "../../utils/sse/apiObjects";
import { documentRequestTemplateJsonRequestCurl } from "../../utils/sse/sampleJsonRequest";
import { documentRequestTemplateJsonResponse } from "../../utils/sse/sampleJsonResponse";

const documentRequestTemplate : API = {
    name: "Document Request Template",
    url: `${API_BASE_URL}/${SSE.DOCUMENT_REQUEST_TEMPLATE.documentRequestTemplate}`,
    method: "GET",
    headers: commonRequestHeader,
    apiInfo: documentRequestTemplateInfo.documentRequestTemplate,
    requestBody: documentRequestTemplateBody,
    responseBody: documentRequestTemplateResponse,
    jsonRequest: documentRequestTemplateJsonRequestCurl,
    jsonResponse: documentRequestTemplateJsonResponse,
}

export const getContent = (apiName: string) => {
    switch (apiName) {
        case 'Document Request Template':
            return documentRequestTemplate;

    }
};